





































































































































































import { date } from "quasar";
import { mapActions } from "vuex";

export default {
  name: "addWebsiteComponent",

  data() {
    return {
      msg: "Add Website",
      displayDurationInSeconds: 10,
      contentName: "",
      date: date.formatDate(
        date.addToDate(Date.now(), { days: 1 }),
        "DD.MM.YYYY HH:mm"
      ),
      effect: { label: "none", value: false },
      effectOptions: [
        { label: "none", value: false },
        { label: "Blink", value: 1 },
        { label: "Bounce", value: 2 },
        { label: "Explode", value: 3 },
        { label: "Swipe", value: 4 },
        { label: "Lines", value: 5 },
      ],
      qrcode: { label: "none", value: false },
      qrCodeOptions: [
        { label: "none", value: false },
        { label: "Mirrads", value: 1 },
        { label: "Youtube", value: 2 },
        { label: "?", value: 3 },
      ],
      message: "",
      lottie: { label: "none", value: false },
      lottieOptions: [
        { label: "none", value: false },
        { label: "Firework", value: 1 },
        { label: "Bell", value: 2 },
        { label: "Clock", value: 3 },
        { label: "Heart", value: 4 },
        { label: "Confetti", value: 5 },
        { label: "Present", value: 6 },
        { label: "Checked", value: 7 },
        { label: "Eye", value: 8 },
        { label: "Smile", value: 9 },
        { label: "Cat", value: 10 },
      ],
    };
  },

  computed: {
    validInput() {
      return (
        this.contentName.length > 0 &&
        this.date.length === 16 &&
        this.displayDurationInSeconds > 0
      );
    },
  },

  methods: {
    ...mapActions(["addNonMediaContent"]),

    postToBackend() {
      const dateTimeParts = this.date.split(" ");
      const extractedDate = dateTimeParts[0].split(".");
      const year = extractedDate[2];
      const month = extractedDate[1];
      const day = extractedDate[0];

      const time = dateTimeParts[1].split(":");
      const minutes = time[0];
      const seconds = time[1];

      let websiteUrl =
        "https://mirrads.de/countdown/countdown.html?date=" +
        year +
        month +
        day +
        "&time=" +
        minutes +
        seconds +
        "00";

      if (this.effect) {
        websiteUrl += "&effect=" + this.effect.value;
      }

      if (this.qrcode) {
        websiteUrl += "&qrcode=" + this.qrcode.value;
      }

      if (this.message.length > 0) {
        websiteUrl += "&message=" + this.message;
      }

      if (this.lottie) {
        websiteUrl += "&lottie=" + this.lottie.value;
      }

      console.log(websiteUrl);

      this.addNonMediaContent({
        contentName: this.contentName,
        src: websiteUrl,
        mimetype: "webview",
        duration: this.displayDurationInSeconds,
      });
    },

    // following method is REQUIRED
    // (don't change its name --> "show")
    show() {
      this.$refs.dialog.show();
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide() {
      this.$refs.dialog.hide();
    },

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit("hide");
    },

    onOKClick() {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit("ok");
      // or with payload: this.$emit('ok', { ... })

      // then hiding dialog
      this.hide();
    },

    onCancelClick() {
      // we just need to hide dialog
      this.hide();
    },
  },
};
